import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { Section, SectionHeading } from '../ui/Section';
import { Reveal } from '../ui/Reveal';
import { faqs } from '../../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const reduceMotion = useReducedMotion();
  return <Section className="bg-white" width="narrow" aria-labelledby="faq-titulo" data-id="element-83" data-mp="1prxubntlwmjz">
      <Reveal data-id="element-84" data-mp="1ur0zr9di0ush">
        <SectionHeading id="faq-titulo" data-id="element-85" data-mp="1urk8bzh9e6tu">Preguntas frecuentes</SectionHeading>
      </Reveal>

      <dl className="mt-9" data-id="element-86" data-mp="1g2xu613dbl47">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={faq.question} className="border-b border-mist" data-id="element-87" data-mp="1l0ftr0vhwnzj" data-mpi={index}>
              <dt data-id="element-88" data-mp="28rbreemmudep">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left transition-colors duration-200 ease-smooth hover:text-gold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-89" data-mp="28qtk8myfmes0">
                  <span className="text-base font-bold text-forest sm:text-lg" data-id="element-90" data-mp="2ygk2erkl5ir1">{faq.question}</span>
                  <PlusIcon className={`mt-1 h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-91" data-mp="2tos6s2mkomu1" />
                </button>
              </dt>
              <AnimatePresence initial={false} data-id="element-92" data-mp="32glr80582how">
                {isOpen && <motion.dd id={`faq-panel-${index}`} className="overflow-hidden" initial={reduceMotion ? undefined : {
              height: 0,
              opacity: 0
            }} animate={reduceMotion ? undefined : {
              height: 'auto',
              opacity: 1
            }} exit={reduceMotion ? undefined : {
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-93" data-mp="3hewa08vumkki">
                    <p className="pb-6 pr-10 text-base leading-relaxed text-muted" data-id="element-94" data-mp="27sae485ud0hj">{faq.answer}</p>
                  </motion.dd>}
              </AnimatePresence>
            </div>;
      })}
      </dl>
    </Section>;
}